import React, { Component } from 'react';
import { _post, _getToken, variable, _Alert, _isLogin } from './Function';
import SideBar from './SideBar';
import Loading from './Loading';
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import '../css/MessageAll.css';

class MessageAll extends Component {
    constructor(props){
        super(props);
        this.state={
            loadingShow: true,
            message: [],
            countMessage: 0,
            path: '/online/message/',
            onRefresh: false
        }
        _isLogin().then( value => { 
            if ( value ) this.getMessage();
        });
    }

    getMessage() {
        let param = { token: _getToken(), platform: variable().platform };
        _post('get.message.php', param)
        .then(res => { 
            this.setState({ loadingShow: false });
            if ( res.data.status ) {
                this.setState({ message: res.data.data, countMessage: res.data.data.length })
            } else {
                if ( res.data.responseText === 101 ) {
                    localStorage.clear();
                    _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                } else {
                    _Alert('modify', 'error', 'แจ้งเตือน', res.data.responseText);
                }
            }

        }).catch(err => { 
            this.setState({ loadingShow: false });
          _Alert('error'); 
        });
    }

    confirmDel(id) {
        const MySwal = withReactContent(Swal);
        MySwal.fire({ 
          title: 'ยืนยันการลบข้อความ ?', 
          text: 'คุณต้องการลบข้อความนี้',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก',
          reverseButtons: true
        }).then((result) => {
          if ( result.value ) {
            console.log("%cClick Delete", "color:white;background-color:gray;padding:2px;");
            this.onDelMessage(id);
          }
        });
    }

    onDelMessage(id) {
        this.setState({ loadingShow: true });
        let param = { token: _getToken(), platform: variable().platform, msg_id: id };
        _post('delete.message.php', param)
        .then(res => { 
            if ( res.data.status ) {
                this.getMessage();
                this.setState({ onRefresh: true });
            } else {
                this.setState({ loadingShow: false });
                if ( res.data.responseText === 101 ) {
                    localStorage.clear();
                    _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                } else {
                    _Alert('modify', 'error', 'แจ้งเตือน', res.data.responseText);
                }
            }

        }).catch(err => { 
            this.setState({ loadingShow: false });
            _Alert('error'); 
        });
    }

    renderMessage() {
        return (
            <div>
                {
                    (this.state.message.length > 0) ?
                        this.state.message.map( (message, index) => (
                            <div key={message.msg_id} className={(index === 0) ? 'msg-all-content is-first' : 'msg-all-content'}>
                                <Link to={this.state.path + message.msg_id} className="msg-all-row">
                                    <div className="msg-all-icon">
                                        { (message.is_read) ? <i className="far fa-envelope-open" /> : <i className="fas fa-envelope" /> }
                                    </div>
                                    <div className="msg-all-title">
                                        {message.msg_title}
                                        <div className="msg-all-time">{message.create_date}</div>
                                    </div>
                                </Link>
                                <div className="msg-all-action"><i className="fas fa-trash-alt" onClick={(e) => this.confirmDel(message.msg_id)}></i></div>
                            </div>
                        ))
                    :
                        <div className="no-data">ไม่พบข้อความถึงคุณ</div>
                }
            </div>
        )
    }

    render() {
        return (
            <div>
                <Loading show={this.state.loadingShow} />
                <SideBar onRefresh={this.state.onRefresh} />

                <div className="content-bar">
                    <div className="card">
                        <div className="card-title">
                            <div className="card-icon"><i className="fas fa-envelope"></i></div>
                            <div className="card-title-text">ข้อความถึงคุณ</div>
                        </div>
                        <div className="card-content">
                            {this.renderMessage()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MessageAll;